<template>
  <div class="industry">
    <div class="title-font-style">工业解决方案</div>
    <div class="illustrate">
      <div>使用XR技术模拟复杂机械设备的装配、调试、维修维护等专业操作培训，提高员工培训效率，降低操作失误率，减少安全风险，为企业降本增效。</div>
    </div>
    <sub-title title-text="行业痛点"></sub-title>
    <div>
      <div class="disadvantage">伴随着工业领域的产业技术升级，数字化工厂的建设对企业传统培训做业流程提出新的挑战。工作流程复杂，设备操作复杂的特定行业需要高效的标准化的操作流程培训与考核。</div>
    </div>
    <div class="hytd-box">
      <div class="hytd">
        <div v-for="(item, index) in prospects" :key="index">
          <div class="images">
            <img :src="item.url" />
          </div>
          <div>
            <div class="title">
              <img :src="item.src" />
              <span>{{ item.title }}</span>
            </div>
            <div>{{ item.content }}</div>
          </div>
        </div>
      </div>
    </div>
    <sub-title title-text="方案优势"></sub-title>
    <div class="fays">
      <img :src="loadUrl.fays_bg" />
      <div>
        <div>
          <div class="title">
            <img src="@/assets/images/solution/xiaolv.png" />
            <span>培训效率提升</span>
          </div>
          <div>XR可视化培训相比传统方式，更为直观易学，有效缩短员工培训时间，提高培训效率。</div>
        </div>
        <div>
          <div class="title">
            <img src="@/assets/images/solution/zaozuo.png" />
            <span>操作流程规范</span>
          </div>
          <div>AR标准化操作流程指导，配置可视化参数，规范员工作业过程，提升员工工作质量，从而提高企业效率。</div>
        </div>
      </div>
      <div>
        <div>
          <div class="title">
            <img src="@/assets/images/solution/hudong.png" />
            <span>互动参与感强</span>
          </div>
          <div>基于实际环境、设备，以三维化多媒体素材为主，过程多样化智能交互，减少对传统纸质手册和专家的依赖，并结合具体情况提供更适合的情景培训。</div>
        </div>
        <div>
          <div class="title">
            <img src="@/assets/images/solution/zichan.png" />
            <span>沉淀数字资产</span>
          </div>
          <div>培训过程中不断积累沉淀企业数字化内容，形成企业自有知识库。</div>
        </div>
      </div>
    </div>
    <div class="yycj">
      <sub-title title-text="应用场景"></sub-title>
      <div class="yycj-content">
        <img :src="loadUrl.industryMp4" />
      </div>
    </div>
    <div class="yyal">
      <sub-title title-text="应用案例"></sub-title>
      <div class="yyal-content">
        <div v-for="(item, index) in casesList" :key="index" @click="toDetail(item.relatedHtmlId, item.title)">
          <img :src="item.ossPath" />
          <div class="content">
            <div class="title">{{ item.title }}</div>
            <div>{{ item.subTitle }}</div>
            <div class="detail">
              {{ item.introduction }}
            </div>
          </div>
        </div>
      </div>
      <div class="pagination">
        <div class="prev" @click="changeData(Math.max(0, paginationIndex - 1) + 1)"></div>
        <div @click="changeData(item)" v-for="(item, index) in paginationValue"
          :class="paginationIndex == index ? 'active' : ''" :key="item">{{
            item }}</div>
        <div class="next" @click="changeData(Math.min(paginationIndex + 1, paginationValue - 1) + 1)"></div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ref, onMounted } from 'vue'
import { selectCommonElement } from '@/api'
import { useRouter } from 'vue-router';
import { useStore } from 'vuex'
import { asynchronousRetrieval } from '@/utils'
import SubTitle from '@/components/SubTitle.vue';
const loadUrl: any = ref({})

const store = useStore()
const router = useRouter()
const casesList: any = ref([])
const casesListAll: any = ref([])
const paginationIndex = ref(0)
const paginationValue = ref(1)

const changeData = (value: number) => {
  paginationIndex.value = value - 1;
  casesList.value = [...casesListAll.value].slice((value - 1) * 5, value * 5)
}

const prospects = [
  {
    title: '互动性较弱',
    content: '传统培训模式互动性和参与感较弱，缺乏场景感，无法达到真实工作环境下的实操模拟培训及考核要求。',
    url: require('@/assets/images/solution/disadvantage1.png'),
    src: require('@/assets/images/solution/disadvantage-icon1.png')
  },
  {
    title: '数字化不足',
    content: '传统培训模式在实际操作过程中缺少量化参数及考核数据，无法形成企业组织培训数字化资产。',
    url: require('@/assets/images/solution/disadvantage2.png'),
    src: require('@/assets/images/solution/disadvantage-icon2.png')
  },
  {
    title: '培训成本高',
    content: '高危行业传统新员工操作培训成本高并带有安全风险，培训成本高，培训效率亟待提高。',
    url: require('@/assets/images/solution/disadvantage3.png'),
    src: require('@/assets/images/solution/disadvantage-icon3.png')
  }
]

const toDetail = (relatedHtmlId: number, title: string) => {
  router.push(`/details?relatedHtmlId=${relatedHtmlId}`)
  store.state.pageTitleStr = `解决方案 / 工业解决方案 / ${title}`
}

onMounted(async () => {
  // 条件判断：只有当数据为空时才请求接口
  // 因为父组件被 keep-alive 缓存，子组件也会被缓存
  // 再次进入页面时 onMounted 仍会执行，但数据已经存在，不需要重新请求
  if (casesListAll.value.length === 0) {
    selectCommonElement({ columnId: 4, appId: 2 }).then((res: any) => {
      casesListAll.value = [...res].filter(e => e.industry == 2).sort((a, b) => (a.sortNum || 0) - (b.sortNum || 0)) || []
      casesList.value = [...casesListAll.value].slice(paginationIndex.value * 5, (paginationIndex.value + 1) * 5)
      paginationValue.value = Math.ceil(casesListAll.value?.length / 5) || 0
    })
  }

  // 条件判断：只有当图片未加载时才请求图片资源
  // 避免重复加载图片，保持缓存状态
  if (!loadUrl.value.fays_bg) {
    const fays_bg: any = await asynchronousRetrieval('nfznxr-images/jjfa/fays-bg.png');
    const industryMp4: any = await asynchronousRetrieval('webimg/gif/industry.gif');
    loadUrl.value = { fays_bg, industryMp4 }
  }
})
</script>
<style scoped lang="less">
.industry {
  background-color: #EFEFEF;
  padding-top: 100rem;
  overflow: hidden;

  .illustrate {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 40rem 0 80rem;

    &>div {
      font-weight: 400;
      font-size: 18rem;
      color: #333333;
      width: 661rem;
      line-height: 30rem;
    }
  }

  .disadvantage {
    padding: 20rem 40rem;
    width: 1204rem;
    display: inline-block;
    background-color: #fff;
    box-sizing: border-box;
    border-radius: 8rem;
    margin: 60rem 0 40rem;
    color: #333;
    font-size: 18rem;
    line-height: 1.5;
    text-align: left;
  }

  .hytd-box {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-bottom: 80rem;

    .hytd {
      width: 1204rem;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;

      &>div {
        width: 394rem;
        font-size: 0;
        box-shadow: 0 0 7rem 0 rgba(0, 0, 0, 0.1);
        border-radius: 8rem;
        overflow: hidden;

        &>div {
          padding: 30rem 29rem;
          font-weight: 400;
          font-size: 16rem;
          color: #5C5C5C;
          line-height: 30rem;
          text-shadow: 0 0 7rem rgba(0, 0, 0, 0.1);
          text-align: left;
          height: 200rem;
          box-sizing: border-box;
          background: #FFFFFF;

          .title {
            font-weight: 600;
            font-size: 22rem;
            color: #333333;
            line-height: 30px;
            text-shadow: 0 0 7rem rgba(0, 0, 0, 0.1);
            font-family: PingFangSC-Medium;
            margin-bottom: 15rem;

            img {
              width: 47rem;
              height: 46rem;
              vertical-align: middle;
            }

            span {
              vertical-align: middle;
            }
          }

          &>div {
            text-align: justify;
          }
        }
      }

      .images {
        width: 393rem;
        height: 330rem;
        background: #F2F4FA;
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding: 0;
        font-size: 0;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .fays {
    position: relative;
    width: 100vw;
    height: 530rem;
    margin-top: 80rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 100rem;
    text-align: left;

    &>img {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
    }

    &>div {
      width: 513rem;
      height: 410rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      margin: 0 5rem;

      &>div {
        width: 513rem;
        height: 200rem;
        background-color: #fff;
        border-radius: 8rem;
        backdrop-filter: blur(10rem);
        font-weight: 400;
        font-size: 16rem;
        color: #333333;
        line-height: 30rem;
        padding: 20rem;
        box-sizing: border-box;
      }

      .title {
        font-weight: 600;
        font-size: 22rem;
        color: #333333;
        line-height: 30rem;
        font-family: PingFangSC-Medium;

        img {
          width: 52rem;
          height: 50rem;
          vertical-align: middle;
        }

        span {
          vertical-align: middle;
        }
      }

      &>div>div:last-child {
        padding: 10rem;
      }
    }
  }

  .yycj {
    background-color: #fff;
    padding-top: 60rem;

    .yycj-content {
      width: 100%;
      height: 629rem;
      margin-top: 50rem;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 1120rem;
        height: 100%;
        border: 1px solid #979797;
        border-radius: 24rem;
      }
    }
  }

  .yyal {
    padding-top: 80rem;
    background-color: #fff;
    overflow: hidden;

    .yyal-content {
      margin: 80rem 0 40rem;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;

      &>div {
        width: 1040rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 60rem;
        padding: 20rem;
        border-radius: 8rem;
        cursor: pointer;

        &:hover {
          box-shadow: 0px 10px 12px 0px rgba(46, 118, 255, 0.2), 0px 0px 4px 0px rgba(46, 118, 255, 0.2);
        }

        img {
          width: 400rem;
          height: 224rem;
        }

        .content {
          width: 607rem;
          height: 224rem;
          text-align: left;
          font-weight: 600;
          font-size: 16rem;
          color: #0A0A0A;
          line-height: 22rem;
          font-family: PingFangSC-Medium;

          .title {
            font-weight: 600;
            font-size: 24rem;
            color: #0A0A0A;
            line-height: 33px;
            margin: 8rem 0 9rem;
          }

          .detail {
            font-weight: 400;
            font-size: 18rem;
            color: #333333;
            line-height: 30rem;
            margin-top: 20rem;
            font-family: PingFangSC-Regular;
          }
        }
      }
    }
  }

  .pagination {
    margin: -50rem 0 67rem;
    display: flex;
    justify-content: center;
    align-items: center;

    &>div {
      width: 24rem;
      height: 24rem;
      line-height: 24rem;
      border-radius: 2rem;
      font-weight: 400;
      font-size: 14rem;
      color: #999999;
      margin: 0 5rem;
      text-align: center;
      cursor: pointer;
    }

    &>div.active {
      background: #F7F7F7;
      color: #414141;
    }

    .prev {
      width: 16rem;
      height: 16rem;
      background-image: url(~@/assets/images/solution/left-c.png);
      background-size: 100% 100%;
    }

    .next {
      width: 16rem;
      height: 16rem;
      background-image: url(~@/assets/images/solution/left-c.png);
      background-size: 100% 100%;
      transform: rotate(180deg);
    }
  }
}
</style>